import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { getMilkCalculationProblems } from "../../utils/milk-calculation-messages.js";
import MilkCalculationProblem from "./MilkCalculationProblem.js";

export const standardMethodLabel = (calculation = {}) => ({
    "legacy-interval-boundary": "Ιστορικός μέσος όρος διαστήματος",
    "legacy-prediction": "Ιστορική πρόβλεψη με συντελεστή",
    "legacy-closing-extension": "Ιστορική επέκταση λήξης",
    interpolated: "Γραμμική παρεμβολή",
    predicted: "Πρόβλεψη με συντελεστή",
    "closing-extension": "Επέκταση λήξης",
    "first-interval": "Πρώτο διάστημα",
    unavailable: "Μη διαθέσιμη",
}[calculation.standardMethod] || "Μη διαθέσιμη");

export const recordingMethodLabel = (calculation = {}) => ({
    "legacy-hours": "Παλιό σύστημα Αμνός — αναγωγή βάσει ωρών",
    AT: "AT — εναλλασσόμενοι έλεγχοι",
    AC: "AC — διόρθωση με ανεξάρτητη μέτρηση εκτροφής",
    "AC-with-fallback": "AC και εκτίμηση βάσει ωρών",
    "interval-fallback": "Εναλλακτική εκτίμηση βάσει ωρών",
    "full-day-sum": "Άθροισμα όλων των αμέλξεων",
    "legacy-daily-total": "Ιστορικό ημερήσιο σύνολο",
    unavailable: "Μη διαθέσιμη",
}[calculation.recordingMethod] || "Μη καταγεγραμμένη μέθοδος");

export const formatMilkKg = (value) => value == null ? "Μη διαθέσιμη" : Number(value).toLocaleString("el-GR", {
    minimumFractionDigits: 3, maximumFractionDigits: 3,
});

const MilkYieldResults = ({ periods }) => (
    <>
        <Typography variant="body2" sx={{ mb: 1 }}>
            Η πραγματική παραγωγή είναι εκτίμηση για την περίοδο άμελξης βάσει των ελέγχων.
            Η τυπική παραγωγή αφορά την ημέρα στόχο της φυλής από τον τοκετό, μετά την περίοδο θηλασμού.
            Πατήστε το εικονίδιο δίπλα σε κάθε πρόβλημα για να δείτε την εξήγησή του.
        </Typography>
        <TableContainer sx={{ border: "1px solid #ddd", mb: 2 }}>
            <Table size="small" aria-label="Πραγματική και τυπική γαλακτοπαραγωγή ανά ζώο">
                <TableHead>
                    <TableRow>
                        <TableCell>Κωδικός ζώου / μητρώου</TableCell>
                        <TableCell>Τοκετός</TableCell>
                        <TableCell align="right">Πραγματική (kg)</TableCell>
                        <TableCell align="right">Τυπική (kg)</TableCell>
                        <TableCell>Ημέρα στόχος / μέθοδος</TableCell>
                        <TableCell>Παρατηρήσεις</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {periods.map((period) => {
                        const problems = getMilkCalculationProblems(period);
                        return (
                            <TableRow key={`${period.animalId}-${period.lambingId}`}>
                                <TableCell>{period.flockCode || "—"} / {period.registrationCode || "—"}</TableCell>
                                <TableCell>{period.lambingDate ? new Date(period.lambingDate).toLocaleDateString("el-GR") : "—"}</TableCell>
                                <TableCell align="right">
                                    {formatMilkKg(period.milk)}
                                    {period.calculation?.periodState === "ongoing" && <Typography variant="caption" display="block">
                                        {[2, 3].includes(period.calcCode) ? "Ανοικτή περίοδος — μερική παραγωγή" : "Ανοικτή περίοδος — έως τον τελευταίο έλεγχο"}
                                    </Typography>}
                                </TableCell>
                                <TableCell align="right">{formatMilkKg(period.standardMilk)}</TableCell>
                                <TableCell>
                                    <Typography variant="body2">{recordingMethodLabel(period.calculation)}</Typography>
                                    {period.calculation?.standardDays ?? "—"} / {standardMethodLabel(period.calculation)}
                                </TableCell>
                                <TableCell>
                                    {problems.length === 0
                                        ? <Typography variant="body2" color="success.main">Χωρίς προβλήματα</Typography>
                                        : problems.map((problem) => <MilkCalculationProblem
                                            key={`${problem.key}-${problem.testDate || ""}`} problem={problem} />)}
                                </TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    </>
);

export default MilkYieldResults;
